var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11483 17.7452C2.71203 17.7452 2.30922 17.6776 1.92297 17.5376C0.758705 17.1151 0 16.1205 0 15.0173V5.57105C0 4.06468 1.39602 2.84558 3.11759 2.84558C4.83916 2.84558 6.23518 4.06709 6.23518 5.57347V8.43655L14.9644 0.798451C16.1811 -0.26615 18.1538 -0.26615 19.3732 0.798451C20.5899 1.86305 20.5899 3.58911 19.3732 4.65612L5.32197 16.9509C4.72605 17.4724 3.92871 17.75 3.11759 17.75L3.11483 17.7452Z",
    fill: "#FFCF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrection);
export default __webpack_public_path__ + "static/media/correction.8ae7b8f57e3de1a45ccff9f729edcae0.svg";
export { ForwardRef as ReactComponent };